import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { BlogIndex, BlogPost, Data, Hello, Home, NotFoundPage } from "@pages";
import { Layout, PageSeo } from "@components";
import { ScrollReviewsToTop } from "./components/ScrollReviewsToTop";
import { reviewsPath } from "./consts/seo";

function RedirectWithHash({ to }: { to: string }) {
  const { hash } = useLocation();
  return <Navigate to={`${to}${hash}`} replace />;
}

function LegacyReviewRedirect() {
  const { slug } = useParams();
  const { hash } = useLocation();
  return <Navigate to={`${reviewsPath}/${slug ?? ""}${hash}`} replace />;
}

export const App = () => {
  return (
    <Layout>
      <PageSeo />
      <ScrollReviewsToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Data />} />
        <Route path="/science" element={<Hello />} />
        <Route path={reviewsPath} element={<BlogIndex />} />
        <Route path={`${reviewsPath}/:slug`} element={<BlogPost />} />
        <Route path="/blog" element={<RedirectWithHash to={reviewsPath} />} />
        <Route path="/blog/:slug" element={<LegacyReviewRedirect />} />
        <Route path="/data" element={<RedirectWithHash to="/explore" />} />
        <Route path="/about" element={<RedirectWithHash to="/science" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
};
